import { render, staticRenderFns } from "./FootprintTableNextButton.vue?vue&type=template&id=542dbafc&scoped=true&"
import script from "./FootprintTableNextButton.vue?vue&type=script&lang=js&"
export * from "./FootprintTableNextButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542dbafc",
  null
  
)

export default component.exports